import { render, staticRenderFns } from "./peace.vue?vue&type=template&id=6ae05f0f&scoped=true"
import script from "./peace.vue?vue&type=script&lang=js"
export * from "./peace.vue?vue&type=script&lang=js"
import style0 from "./peace.vue?vue&type=style&index=0&id=6ae05f0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae05f0f",
  null
  
)

export default component.exports